"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChallengeCardProgressionDescription = ChallengeCardProgressionDescription;
var _DialogContent2 = _interopRequireDefault(require("@mui/material/DialogContent"));
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _Box2 = _interopRequireDefault(require("@mui/material/Box"));
var _Dialog3 = _interopRequireDefault(require("@mui/material/Dialog"));
var _Button3 = _interopRequireDefault(require("@mui/material/Button"));
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ChallengeCardProgressionDescription(_ref) {
  let {
    Button: _Button,
    Dialog: _Dialog,
    geogroup,
    disabled
  } = _ref;
  const [dialogOpen, openDialog] = (0, _react.useState)(false);
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const Button = _Button || _Button3.default;
  const Dialog = _Dialog || _Dialog3.default;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Box2.default, null, /*#__PURE__*/_react.default.createElement(Button, {
    color: "primary",
    disabled: disabled,
    onClick: () => openDialog(true),
    size: "small",
    sx: {
      fontSize: '0.9rem',
      lineHeight: 1.15
    },
    variant: "text"
  }, t('commons.challenges.explanations_dialog.title'))), /*#__PURE__*/_react.default.createElement(Dialog, {
    fullWidth: true,
    maxWidth: "sm",
    onClose: () => openDialog(false),
    open: dialogOpen
  }, /*#__PURE__*/_react.default.createElement(_DialogContent2.default, {
    sx: _Dialog ? {
      padding: 0
    } : {}
  }, /*#__PURE__*/_react.default.createElement(_Box2.default, {
    display: "flex",
    flexDirection: "column",
    gap: 3
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    fontSize: "1.25rem",
    fontWeight: 600
  }, t('commons.challenges.explanations_dialog.title')), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    component: "ul",
    variant: "body2"
  }, geogroup?.type === 'city' && /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    components: [/*#__PURE__*/_react.default.createElement("b", {
      key: 0
    })],
    i18nKey: "commons.challenges.explanations_dialog.city_community",
    values: {
      geogroupTitle: geogroup.title
    }
  })), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    components: [/*#__PURE__*/_react.default.createElement("b", {
      key: 0
    })],
    i18nKey: "commons.challenges.explanations_dialog.join_date"
  })), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    components: [/*#__PURE__*/_react.default.createElement("b", {
      key: 0
    })],
    i18nKey: "commons.challenges.explanations_dialog.too_fast"
  })), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_reactI18next.Trans, {
    components: [/*#__PURE__*/_react.default.createElement("b", {
      key: 0
    })],
    i18nKey: "commons.challenges.explanations_dialog.gpx_import"
  }))), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    display: "flex",
    gap: 3,
    justifyContent: "flex-end"
  }, /*#__PURE__*/_react.default.createElement(Button, {
    color: "primary",
    onClick: () => openDialog(false),
    variant: "contained"
  }, t('commons.actions.understood')))))));
}